import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Decorative, Core } from "@faire/design-tokens";
import { isProductOptionInStock } from "@faire/retailer-visitor-shared/lib/productOptions";
import { showProductPromotions } from "@faire/retailer-visitor-shared/lib/showProductPromotions";
import { getProductOptions } from "@faire/retailer-visitor-shared/views/product/utils/productUtils";
import { formatMoney } from "@faire/web--source/common/money";
import Checkbox from "@faire/web--source/slate/Checkbox";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Span, Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var TesterCheckbox = function(param) {
    var product = param.product, includesTesters = param.includesTesters, selectedOption = param.selectedOption, perStyleOptionVariations = param.perStyleOptionVariations, onTesterCheckboxChange = param.onTesterCheckboxChange;
    var _product_purchase_information, _product_purchase_information_tester_promo_price;
    var hasProductOptionWithTesters = getProductOptions(product).some(function(option) {
        return option.has_testers;
    });
    if (!((_product_purchase_information = product.purchase_information) === null || _product_purchase_information === void 0 ? void 0 : _product_purchase_information.tester_price) || !hasProductOptionWithTesters) {
        return null;
    }
    if (!selectedOption || !isProductOptionInStock(selectedOption, perStyleOptionVariations) || !selectedOption.has_testers) {
        return /*#__PURE__*/ _jsx(Spacer, {
            size: 20
        });
    }
    var _product_purchase_information_tester_promo_price_discounted_item_price;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Checkbox, {
                checked: includesTesters,
                onChange: onTesterCheckboxChange,
                children: /*#__PURE__*/ _jsx(Typography, {
                    "data-test-id": "add-to-cart-include-tester",
                    children: showProductPromotions(product.purchase_information.tester_promo_price) ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "0SNwnz",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Include a Tester for "
                            },
                            {
                                type: 8,
                                value: "StrikeThroughFormatting",
                                children: [
                                    {
                                        type: 1,
                                        value: "originalTesterMoney"
                                    }
                                ]
                            },
                            {
                                type: 0,
                                value: " "
                            },
                            {
                                type: 8,
                                value: "RustFormatting",
                                children: [
                                    {
                                        type: 1,
                                        value: "discountedTesterMoney"
                                    }
                                ]
                            }
                        ],
                        values: {
                            originalTesterMoney: formatMoney({
                                money: product.purchase_information.tester_price
                            }),
                            discountedTesterMoney: formatMoney({
                                money: product.purchase_information.tester_promo_price.discounted_item_price
                            }),
                            StrikeThroughFormatting: strikeThroughFormatting,
                            RustFormatting: rustFormatting
                        }
                    }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "bTJMhn",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Include a Tester for "
                            },
                            {
                                type: 1,
                                value: "testerMoney"
                            }
                        ],
                        values: {
                            testerMoney: formatMoney({
                                money: (_product_purchase_information_tester_promo_price_discounted_item_price = (_product_purchase_information_tester_promo_price = product.purchase_information.tester_promo_price) === null || _product_purchase_information_tester_promo_price === void 0 ? void 0 : _product_purchase_information_tester_promo_price.discounted_item_price) !== null && _product_purchase_information_tester_promo_price_discounted_item_price !== void 0 ? _product_purchase_information_tester_promo_price_discounted_item_price : product.purchase_information.tester_price
                            })
                        }
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "3x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.subdued,
                        variant: "labelSansRegular",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "wNO/vX",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Tester items are not returnable"
                                }
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            })
        ]
    });
};
var strikeThroughFormatting = function(chunk) {
    return /*#__PURE__*/ _jsx(StrikeThrough, {
        children: chunk
    });
};
var rustFormatting = function(chunk) {
    return /*#__PURE__*/ _jsxs(Span, {
        color: Decorative.shade.orange,
        children: [
            " ",
            chunk,
            " "
        ]
    });
};
var StrikeThrough = styled.span.withConfig({
    componentId: "sc-80256456-0"
})([
    "text-decoration:line-through;color:",
    ";"
], Core.text.subdued);
